export default "__VITE_ASSET__DevqfVDU__"